export const GET_ALL_QUIZ_REQUEST = 'GET_ALL_QUIZ_REQUEST'
export const GET_ALL_QUIZ_SUCCESS = 'GET_ALL_QUIZ_SUCCESS'
export const GET_ALL_QUIZ_FAILED = 'GET_ALL_QUIZ_FAILED'